import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthProvider";
import BrandHeading from "@/components/brand/BrandHeading";
import BrandLabel from "@/components/brand/BrandLabel";
import BrandButton from "@/components/brand/BrandButton";
import BrandInput, { BrandField } from "@/components/brand/BrandInput";

const SignIn = () => {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await signIn(email, name);
      navigate("/bookings");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-rail py-12 md:py-20 grid lg:grid-cols-[1.2fr_1fr] gap-12 items-start" data-testid="signin-page">
      <div>
        <BrandLabel withRule>Welcome</BrandLabel>
        <BrandHeading level={1} className="mt-4">Sign in to your stays.</BrandHeading>
        <p className="mt-5 max-w-[58ch] text-muted-foreground leading-relaxed">
          Sign in to keep your favourites across the GMH portfolio, track Castlewood and Vela bookings, and follow your Brionj enquiries through to confirmation.
        </p>
        <p className="mt-3 text-[12px] text-muted-foreground">This is a sales-pitch prototype. Any email works — we don't send anything.</p>
      </div>
      <form onSubmit={submit} className="border border-border p-6 md:p-8 rounded-[var(--radius)] bg-card">
        <BrandField label="Email" htmlFor="signin-email" required>
          <BrandInput id="signin-email" data-testid="signin-email-input" type="email" value={email} placeholder="you@example.com" onChange={(e) => setEmail(e.target.value)} required />
        </BrandField>
        <div className="mt-4" />
        <BrandField label="Name (optional)" htmlFor="signin-name">
          <BrandInput id="signin-name" data-testid="signin-name-input" value={name} placeholder="Jane Traveller" onChange={(e) => setName(e.target.value)} />
        </BrandField>
        <div className="mt-6 flex flex-col gap-3">
          <BrandButton type="submit" disabled={loading} data-testid="signin-submit">{loading ? "Signing in…" : "Sign in"}</BrandButton>
          <button type="button" className="text-[12px] text-muted-foreground underline" onClick={() => { setEmail("anna.berg@example.com"); setName("Anna Berg"); }} data-testid="signin-demo-fill">
            Use demo account
          </button>
        </div>
      </form>
    </div>
  );
};
export default SignIn;
